import { fg } from '@atlaskit/platform-feature-flags';

import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';
import { isProductOneOf } from './is-product-one-of';

/**
 * Eligibility for Premium Add Payment Modal (JSM/JPD in trial).
 */
export function isEligibleForPremiumAddPaymentModal(context: EditionAwarenessContextType): boolean {
	const { product, edition, isInTrial, invoiceableStatus, canAddPaymentDetails } = context;

	if (fg('ea_audience_and_timing_refactor')) {
		return Boolean(
			isEditionOneOf(edition, ['premium']) &&
			isInTrial &&
			isProductOneOf(product, ['jira-service-management', 'jira-product-discovery']) &&
			invoiceableStatus === 'NOT_INVOICEABLE' &&
			canAddPaymentDetails,
		);
	}

	return Boolean(
		isEditionOneOf(edition, ['premium']) &&
		isInTrial &&
		isProductOneOf(product, ['jira-service-management', 'jira-product-discovery']),
	);
}
